/* Built In Imports */
import React from 'react';
import { useTimer } from 'react-timer-hook';

/* External Imports */
import { Box, Image, Link, Text } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
/* Services */

/**
 * Renders the BannerContentSgx component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} BannerContent component
 */

const BannerContentSgx = ({ sectionContent, region, language, pagetitle }) => {
  const bannerDetail = sectionContent.body?.find(
    el => el.sectionId == 'HeaderBanner'
  );
  const bannerData = bannerDetail?.sectionContent;

  // const time = new Date(`10/15/2022`);
  const time = new Date(bannerData[11]?.text);

  /**
   *
   * @param root0
   * @param root0.expiryTimestamp
   */
  function MyTimer({ expiryTimestamp }) {
    const {
      seconds,
      minutes,
      hours,
      days,
      isRunning,
      start,
      pause,
      resume,
      restart,
    } = useTimer({
      expiryTimestamp,
      onExpire: () => console.warn('onExpire called'),
    });

    return (
      <Box textAlign="center" maxH="86px" m="16px 0">
        <Box fontFamily="FedraSansStd-book" fontWeight="600" color="#ffffff">
          <Box
            as="div"
            display="inline-block"
            textAlign="center"
            width={{ base: '50px', lg: '68px' }}
          >
            <Text as="span" fontSize="16px" color="#ffffff">
              DY
            </Text>
            <br />
            <Text
              as="span"
              fontSize={{ base: '36px', lg: '54px' }}
              className="clocknum"
            >
              {days}
            </Text>
          </Box>
          <Box as="div" className="clockseparator">
            :
          </Box>
          <Box
            as="div"
            display="inline-block"
            textAlign="center"
            width={{ base: '50px', lg: '68px' }}
          >
            <Text as="span" fontSize="16px" color="#ffffff">
              HRS
            </Text>
            <br />
            <Text
              as="span"
              fontSize={{ base: '36px', lg: '54px' }}
              className="clocknum"
            >
              {hours}
            </Text>
          </Box>
          <Box as="div" className="clockseparator">
            :
          </Box>
          <Box
            as="div"
            display="inline-block"
            textAlign="center"
            width={{ base: '50px', lg: '68px' }}
          >
            <Text as="span" fontSize="16px" color="#ffffff">
              MIN
            </Text>
            <br />
            <Text
              as="span"
              fontSize={{ base: '36px', lg: '54px' }}
              className="clocknum"
            >
              {minutes}
            </Text>
          </Box>
          <Box as="div" className="clockseparator">
            :
          </Box>
          <Box
            as="div"
            display="inline-block"
            textAlign="center"
            width={{ base: '50px', lg: '68px' }}
          >
            <Text as="span" fontSize="16px" color="#ffffff">
              SEC
            </Text>
            <br />
            <Text
              as="span"
              fontSize={{ base: '36px', lg: '54px' }}
              className="clocknum"
            >
              {seconds}
            </Text>
          </Box>
        </Box>
      </Box>
    );
  }
  const SubscribeButton = ({ btnobj, pagetitle }) => {
    let extraDomains = '';
    {
      pagetitle === 'Sadhguru Exclusive Renew' &&
        (extraDomains = '//isha.sadhguru.org');
    }
    return (
      <>
        {btnobj?.buttonText != '' && (
          <Box>
            <Link
              w={{ base: '80%', lg: '368px' }}
              h={{ base: '51px', lg: '81px' }}
              m="5px auto 10px auto"
              fontFamily="FedraSansStd-A-medium"
              fontSize={{ base: '16px', md: '20px' }}
              lineHeight={{ base: '51px', lg: '81px' }}
              textAlign="center"
              display="block"
              background="#ffbd31"
              color="#121212"
              borderRadius="7px"
              className="buttonlink"
              href={refineUrlDomain(
                btnobj?.linkUrl,
                region,
                language,
                extraDomains
              )}
              _hover={{ textDecor: 'none' }}
              cursor="pointer"
            >
              {btnobj?.buttonText}
            </Link>
          </Box>
        )}
      </>
    );
  };
  const Additionalcontent = () => {
    return (
      <>
        <Box display={{ base: 'none', lg: 'block' }}>
          <LazyLoadImageComponent
            src={bannerData[0]?.image?.url}
            alt={bannerData[0]?.image?.alt}
            width={{ lg: '350px', base: '249px' }}
          />
        </Box>
        <Box display={{ base: 'block', lg: 'none' }} m="10px 0 20px 0">
          <LazyLoadImageComponent
            src={bannerData[0]?.mobileImage?.url}
            alt={bannerData[0]?.image?.alt}
            width={{ lg: '350px', base: '249px' }}
          />
        </Box>
        <Text
          color={{ base: '#FFBD31', lg: '#FFBD31' }}
          fontSize={{ lg: '32px', base: '23px' }}
          fontFamily="FedraSansStd-medium"
          width={{ base: '90%', lg: '390px' }}
          m="0 auto"
        >
          {bannerData[1]?.text}
        </Text>{' '}
        <Text
          color={{ base: '#FFFFFF', lg: '#FFFFFF' }}
          fontSize={{ lg: '18px', base: '13px' }}
          fontFamily="FedraSansStd-book"
          fontStyle="italic"
          mt="10px"
        >
          {bannerData[2]?.text}
        </Text>
        <MyTimer expiryTimestamp={time} />
        <SubscribeButton btnobj={bannerData[4]} pagetitle={pagetitle} />
        {/* <Box
          fontSize={{ base: '14px', lg: '16px' }}
          fontFamily="FedraSansStd-medium"
          color="#b0a999"
          margin="15px 0 0 0"
          className="loginlink"
        >
          {StructuredTextContent(bannerData[6]?.body)}
        </Box> */}
      </>
    );
  };
  return (
    <>
      <Box>
        <Box
          background={{
            base: `url('${bannerData[3]?.mobileImage?.url}') no-repeat top center`,
            md: `url('${bannerData[3]?.image?.url}') no-repeat top center`,
            lg: `url('${bannerData[3]?.image?.url}') no-repeat top center`,
          }}
          backgroundSize={{ base: 'cover', md: 'contain', lg: 'contain' }}
          textAlign="center"
          m="0 auto"
          className="banner_content"
          position="relative"
          height={{ base: '248px', lg: 'auto' }}
        >
          <Box
            // background={{
            //   base: `url('${config.imgPath}/d/46272/1662631617-sgxblack-paint-loop_mobile.png') repeat-x`,
            //   lg: `url('${config.imgPath}/d/46272/1662616185-sgxblack-paint-loop.png') repeat-x`,
            // }}
            // backgroundPosition={{ base: 'bottom', lg: 'bottom' }}
            // backgroundRepeat="repeat-x"
            padding={{ base: '25px', lg: '15px 200px 55px 47%' }}
            // backgroundSize={{ base: 'cover', md: '90%', lg: '100%' }}
          >
            <Box
              width={{ base: '50%', md: 'auto' }}
              marginLeft={{ base: 'auto', lg: '0' }}
              height={{ base: '200px', lg: 'auto' }}
              display={{ base: 'none', lg: 'block' }}
            >
              <Image
                src={`${config.imgPath}/d/46272/1662725228-sgx.png`}
                title="logo"
                alt="logo"
              />
            </Box>
            <Box display={{ base: 'none', lg: 'block' }}>
              <Additionalcontent />
            </Box>
          </Box>
        </Box>
        <Box
          display={{ base: 'block', lg: 'none' }}
          width="90%"
          m="0 auto 20px auto"
          textAlign="center"
        >
          <Additionalcontent />
        </Box>
        <Box
          as="h2"
          fontSize={{ base: '24px', md: '40px', lg: '40px' }}
          fontFamily="FedraSansStd-medium"
          color="#ffffff"
          width={{ base: '90%', md: '40%' }}
          m="0 auto 20px auto"
          lineHeight="110%"
          textAlign="center"
        >
          {bannerData[5]?.titleText}
        </Box>
        <Box
          color="#ffffff"
          fontSize={{ base: '16px', lg: '18px' }}
          fontFamily="FedraSansStd-book"
          m="10px auto 30px auto"
          width={{ base: '88%', lg: '630px' }}
          textAlign={{ base: 'left', md: 'center' }}
        >
          {StructuredTextContent(bannerData[6]?.body)}
        </Box>
        <Box
          fontSize={{ base: '16px', lg: '22px' }}
          fontFamily="FedraSansStd-book"
          color="#ffffff"
          margin="20px auto"
          padding={{ base: '20px 26px', lg: '20px 32px' }}
          backgroundColor="#2F2C29"
          maxW={{ base: '90%', lg: '850px' }}
          borderRadius="8px"
          textAlign="center"
          className="sgquote"
        >
          {StructuredTextContent(bannerData[7]?.body)}
        </Box>
        {/* <Box m={{ base: '10px auto 20px auto', lg: '10px 200px 20px 200px' }}>
          <SubscribeButton btnobj={bannerData[8]} />
        </Box> */}
        <style global jsx>{`
          .clocknum {
            color: #ffbd31;
            line-height: 60px;
          }
          .clockseparator {
            opacity: 0.6;
            font-size: 54px;
            display: inline-block;
          }
          .sgquote strong {
            padding-top: 20px;
            font-weight: 600;
          }
          @media only screen and (max-width: 767px) {
            .clockseparator {
              font-size: 20px;
              vertical-align: text-bottom;
              padding-bottom: 3px;
            }
          }
        `}</style>
      </Box>
    </>
  );
};

export default BannerContentSgx;
